import React, { useEffect, useMemo, useState } from 'react';
import { buildLdaTree, collectLdaGroupIds, filterLdaTree, getLdaFilterOptions } from '../buildLdaTree';
import LdaTreeFilters from './LdaTreeFilters';
import LdaTreeToolbar from './LdaTreeToolbar';
import LdaTreeNode from './LdaTreeNode';

const EMPTY_FILTERS = { search: '', phase: '', lot: '', status: '' };

export default function LdaTreeView({ project, resolvedNodes, rows, loading, renderDeliverable }) {
  const [filters, setFilters] = useState(EMPTY_FILTERS);
  const tree = useMemo(() => buildLdaTree({ project, resolvedNodes, lines: rows }), [project, resolvedNodes, rows]);
  const filteredTree = useMemo(() => filterLdaTree(tree, filters), [tree, filters]);
  const groupIds = useMemo(() => collectLdaGroupIds(filteredTree), [filteredTree]);
  const [expanded, setExpanded] = useState(() => new Set());
  useEffect(() => { setExpanded(new Set(groupIds)); }, [groupIds]);
  const toggle = (id) => setExpanded((current) => { const next = new Set(current); next.has(id) ? next.delete(id) : next.add(id); return next; });
  return <section className="lda-tree" aria-label="Arborescence LDA">
    <LdaTreeFilters filters={filters} options={getLdaFilterOptions(rows)} onChange={setFilters} />
    <LdaTreeToolbar count={filteredTree?.metadata.deliverableCount || 0} progress={filteredTree?.metadata.progress || 0}
      onExpandAll={() => setExpanded(new Set(groupIds))} onCollapseAll={() => setExpanded(new Set())} />
    {loading ? <div className="loading-state">Chargement de la LDA…</div> : filteredTree
      ? <LdaTreeNode node={filteredTree} expanded={expanded} onToggle={toggle} renderDeliverable={renderDeliverable} />
      : <div className="time-entry-empty">Aucun livrable ne correspond aux filtres.</div>}
  </section>;
}
